/* eslint-disable */
import React from 'react'
import { useFormContext } from 'react-hook-form'
import { TextField } from '@edge/spark/feature-mui-rhf-inputs'
import { convertAQLToDashboardCardFilters } from './converters'
import { objectDiffByPath } from './utils/objectDiffByPath'

const name = 'aql'

export const AuctionQueryLanguage: React.VFC = () => {
    const { getValues, setValue } = useFormContext()

    return (
        <TextField
            name={name}
            onBlur={(e) => {
                const aql = e.target.value
                const priorFilters = getValues('filters')
                const nextFilters = convertAQLToDashboardCardFilters(aql)
                const diff = objectDiffByPath(priorFilters, nextFilters)
                Object.entries(diff).forEach(([key, value]) => {
                    setValue(`filters.${key}`, value)
                })
            }}
            label="Auction Query Language"
            fullWidth
        />
    )
}

export default AuctionQueryLanguage
